import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { InfoOutlined } from '@material-ui/icons'
import { IHistoryEvent } from '../../types/history'
import { IContinuationState } from '../../types/continuationScroll'
import * as date from '../../services/date'
import { ContinuationList } from '../../layouts/'
import { P } from '../StyledText'

export const HistoryEventList = ({
  items,
  continuationToken,
  isLoading,
}: IContinuationState<IHistoryEvent>) => (
  <ContinuationList>
    <li className="list-header">
      <P>Modified by</P>
      <P>Created</P>
      <P className="large">Details</P>
    </li>
    {items.map(
      ({ message, created, createdBy: { name } }: IHistoryEvent, i) => (
        <li key={i}>
          <InfoOutlined className="icon" />
          <P className="name">{name}</P>
          <P className="date">{date.calendar(created, 'FULL')}</P>
          <P className="message">{message}</P>
        </li>
      )
    )}
    <li className="list-footer">
      {isLoading ? (
        <CircularProgress />
      ) : !items.length || !continuationToken ? (
        <P className="no-items-text">No more items</P>
      ) : null}
    </li>
  </ContinuationList>
)
